import {isEmpty, isNil, isNotNil, keys} from 'ramda';

import {DrillDownLevel, DrillDownLevelName} from '@dms/api/core';

import {getSafely, Nullish} from 'shared/web';

export function getPermanentLevelFilters(
  permanentFilters: Partial<Record<DrillDownLevelName, string>> | Nullish
): DrillDownLevel[] {
  if (isNil(permanentFilters) || isEmpty(permanentFilters)) {
    return [];
  }

  return keys(permanentFilters)
    .filter((levelName) => isNotNil(getSafely(permanentFilters, levelName)))
    .map((levelName, index) => ({
      level: levelName,
      values: [getSafely(permanentFilters, levelName)!],
      priority: index + 1,
    }));
}
